/* eslint-disable no-use-before-define,react-hooks/exhaustive-deps */
import React from 'react'
import { Formik } from 'formik'
import { Field, FieldArray } from 'formik'
import { Flyout, Fields, Status, CALL_FEATURES, STATES, isEmpty, parseDate, Loading} from '../twd/twd'
import { Table } from './table'
import { Chart } from './chart'
import { Summary, SearchSummary } from './summary'
import { ErrorBoundary, getDefaultValues,useTeyCalculator} from './tey-calculator'
import { calculate } from "./calculate"
import { onSubmit } from './submit'

export default ({ts:_ts}) => {
    let [ts, setTs] = React.useState(_ts)
    const [status, setStatus] = React.useState(Status.LOADING)
    const [error, setError] = React.useState('')
    const [calculation, setCalculation] = React.useState(null)
    const [taxState, setTaxState] = React.useState('')

    const { state, } = useTeyCalculator()

    React.useEffect(() => {
        if (!_ts || ts >= _ts) return
        setTs(_ts)
        setStatus(Status.LOADING)
        setError('')
        setCalculation(null)
    }, [ts, _ts])

    React.useEffect(() => {
        if (!ts) return
        ;(async ()=> {
            try {
                let values = {...(state.value.input)}
                let calc = await calculate(values)
                setCalculation(calc)
                setTaxState(values.taxState || '')
                setStatus(Status.LOADED)
            } catch(e) {
                setError('Unable to calculate')
                setStatus(Status.FAILED_TO_LOAD)
            }
        })()
    }, [ts])

    if (!_ts) return null


    return <Loading status={status} error={error}>
        <ErrorBoundary>
        <Formik
            initialValues={{
                ...(getDefaultValues().search),
                ...state.value.search,
                calculation,
                taxState,
            }}
            onSubmit={(values) => {
                state.set({
                    ...getDefaultValues(),
                })
                onSubmit(values)
            }}
            component={Form}
            validate={(values) => {
                state.set({
                    ...state.value,
                    search: {...values}
                })
                return onValidate(values)
            }}
            validateOnBlur={true}
            validateOnChange={true}
        />
        </ErrorBoundary>
        </Loading>
}


let onValidate = (values) => {
    let err = {}

    let minMat = parseDate(values.holdMaturityMin)
    if (values.holdMaturityMin && !minMat ) {
        err.holdMaturityMin = 'Enter date'
    }

    let maxMat = parseDate(values.holdMaturityMax)
    if (values.holdMaturityMax && !maxMat ) {
        err.holdMaturityMax = 'Enter date'
    }

    if (maxMat < minMat) {
        err.holdMaturityMax = 'Enter later date'
    }

    if (!values.searchFor) {
        err.searchFor = 'Select value'
    }

    if (values.searchFor==='muni_in' && isEmpty(values.muniInStates)) {
        err.muniInStates = 'Select state'
    }

    if (values.searchFor==='muni_out' && isEmpty(values.muniOutStates)) {
        err.muniOutStates = 'Select state'
    }

    return err
}

let Form = ({
    handleSubmit,
    values,
    errors,
}) => {

    let hasError = Object.keys(errors).length>0
    let isMuniIn = values.searchFor === 'muni_in'
    let isMuniOut = values.searchFor === 'muni_out'
    let isTsy = values.searchFor === 'tsy'

    return <form onSubmit={handleSubmit}>
    <div className="row">
        <div className="col-md-12">
            <h5>Tax-equivalent yields by bond product type</h5>
        </div>
    </div>

    <div className="row">
        <div className="col-md-6 table-responsive vertical-offset-base">
            <Table calculation={values.calculation} />
        </div>
        <div className="col-md-6 vertical-offset-base">
            <Chart calculation={values.calculation} />
        </div>
    </div>

    <div className="row">
        <div className="col-md-12">
            <h5>Search for comparable bonds</h5>
        </div>
    </div>

    <div className="row vertical-offset-sm">
        <div className="col-md-12">
            <Summary calculation={values.calculation} />
        </div>
    </div>

    <div className="row">
        <div className={"col-xs-12 col-auto vertical-offset-xs"} style={{minWidth:'160px', }}>
        <Field
            dataName="tey-calculator-securities"
            name="searchFor"
            component={Fields.Select}
            label="Search for"
            options={[
                {label:'', value:''},
                {label:'In-state municipal', value:'muni_in'},
                {label:'Out-of-state muni', value:'muni_out'},
                {label:'Corporate', value:'corp'},
                {label:'Treasury', value:'tsy'}
            ]}
        />
        </div>

        <div className="col-xs-12 col-auto vertical-offset-xs">
        <Field
            data-name="tey-calculator-maturity-min"
            name="holdMaturityMin"
            component={Fields.Maturity}
            label={<Flyout label="Maturity Min" html={Fields.Labels.Maturity} />}
            error={errors.holdMaturityMin}
        />
        </div>
        <div className="col-xs-12 col-auto vertical-offset-xs">
        <Field
            data-name="tey-calculator-maturity-max"
            name="holdMaturityMax"
            component={Fields.Maturity}
            label={<Flyout label="Maturity Max" html={Fields.Labels.Maturity} />}
            error={errors.holdMaturityMax}
        />
        </div>

        {!isTsy && <div className="col-xs-12 col-auto vertical-offset-xs" style={{minWidth:'100px', }}>
        <FieldArray
            name="callFeatures"
            render={(args) => <Fields.SelectMulti {...args}
                dataName="tey-calculator-features"
                options={CALL_FEATURES}
                label={<Flyout label="Call features" html={Fields.Labels.CallFeatures} />}
                listConfig={{ style: { minWidth:'150px' } }}
                style={{marginBottom:'0px'}}
            />}
        />
        </div>}

        {isMuniIn && <div className="col-xs-12 col-auto vertical-offset-xs" style={{minWidth:'100px', }}>
            <FieldArray
                name="muniInStates"
                render={(args) => <Fields.SelectMulti
                    {...args}
                    dataName="tey-calculator-muni-in-states"
                    emptyText=""
                    showSelectAll={true}
                    options={STATES}
                    label="State"
                    listConfig={{ style: { minWidth:'200px' } }}
                    error={errors.muniInStates}
                    style={{marginBottom:'0px'}}
                />}
            />
            {errors.muniInStates &&
                <label className="field-status has-error">{errors.muniInStates}</label>}
        </div>}

        {isMuniOut && <div className="col-xs-12 col-auto vertical-offset-xs" style={{minWidth:'100px', }}>
            <FieldArray
                name="muniOutStates"
                render={(args) => <Fields.SelectMulti
                    {...args}
                    dataName="tey-calculator-muni-out-states"
                    emptyText=""
                    showSelectAll={true}
                    options={STATES}
                    label="State"
                    listConfig={{ style: { minWidth:'200px' } }}
                    error={errors.muniOutStates}
                    style={{marginBottom:'0px'}}
                />}
            />
            {errors.muniOutStates &&
                <label className="field-status has-error">{errors.muniOutStates}</label>}

        </div>}

        <div className={"col-xs-12 col-auto vertical-offset-xs"} style={{minWidth:'100px'}}>
            <label>&nbsp;</label>
            <button
                type="submit"
                disabled={hasError}
                className="btn btn-primary-outline btn-block"
            >Search</button>
        </div>
    </div>

    <div className="row">
    <div className="col-md-12">
        <SearchSummary {...values} />
    </div>
    </div>

   </form>
}